// A summary is plain text; publisher tracking URLs and Markdown belong in the reader.
export const emailPreviewText = value => String(value || '')
    .replace(/!\[[^\]]*\]\([^)]*\)/g, '')
    .replace(/\[([^\]]+)\]\([^)]*\)/g, '$1')
    .replace(/https?:\/\/[^\s<>)]*/gi, '')
    .replace(/<[^>]*>/g, '')
    .replace(/[\u034f\u200b-\u200f\u2060\ufeff]/g, '')
    .replace(/(?:^|\n)\s*#{1,6}\s+/g, ' ')
    .replace(/[*_`]/g, '')
    .replace(/\s+/g, ' ').trim().slice(0, 220);
